import request from "../../../utils/request";

export const getFinanceRefundList = '/finance/refund/';

export function getFinanceRefundDetail(id: number) {
    return request.request({
        url: '/finance/refund/detail',
        method: "get",
        params: {id: id}
    })
}